// Mapeo de actividades económicas según el libro "Capitalismo de Abundancia"
// Cada sector incluye diagnóstico, propuesta, cifras y instrumentos.
export const SECTORES = [
  {
    id: "turismo",
    nombre: "Turismo Interno",
    icon: "MapPin",
    capitulo: "Cap. 24 · Parte V",
    metricaPrincipal: "25.000 PVA",
    metricaLabel: "por persona para turismo",
    diagnostico: "El turismo interno no es accesorio recreativo: es política económica, territorial, cultural y emocional. La Argentina es una geografía inmensa y diversa, desconocida para millones de sus habitantes.",
    propuesta: "Organizar el territorio en grandes corredores de demanda sostenida con identidad propia, marca regional y estándares de calidad. Cada argentino recibe componente turístico en PVA, utilizable en red de prestadores certificados (hoteles, transporte, gastronomía).",
    cifras: [
      { label: "PVA turísticos por persona", valor: "25.000" },
      { label: "Corredores turísticos federales", valor: "5+" },
    ],
    instrumentos: ["PVA turístico", "BVA", "BICE", "Certificación de prestadores"],
    horizonte: "mediano",
    proyeccion: "La mayor inyección de demanda doméstica planificada de la historia argentina.",
  },
  {
    id: "litio",
    nombre: "Minería del Litio",
    icon: "Battery",
    capitulo: "Cap. 25 · Parte V",
    metricaPrincipal: "3-5% → 30-40%",
    metricaLabel: "del valor de cadena capturado",
    diagnostico: "Argentina exporta ~80.000 toneladas de carbonato de litio casi todo en concentrado sin procesar. La diferencia entre lo que cobramos y el valor de una batería instalada es el costo del fracaso extractivo.",
    propuesta: "Industrialización en 4 escalones: 1) Carbonato grado batería, 2) Hidróxido de litio, 3) Cátodos y ánodos, 4) Celdas y paquetes de baterías. Procesar al menos el 50% del litio en Argentina antes de exportarlo.",
    cifras: [
      { label: "Valor actual capturado", valor: "3-5%" },
      { label: "Objetivo", valor: "30-40%" },
      { label: "Multiplicador procesamiento básico", valor: "x4" },
    ],
    instrumentos: ["Regalía diferencial (5% procesado / 25% bruto)", "Procesamiento obligatorio", "BICE", "FDRE"],
    horizonte: "mediano",
    proyeccion: "Industria de baterías argentina comparable a la china en 10 años.",
  },
  {
    id: "cobre",
    nombre: "Minería del Cobre",
    icon: "Mountain",
    capitulo: "Cap. 25 · Parte V",
    metricaPrincipal: "+40%",
    metricaLabel: "valor por cátodo refinado",
    diagnostico: "Argentina tiene reservas cupríferas de primer nivel pero exporta concentrado mineral. La diferencia de valor entre concentrado y cátodo refinado es ~40% del precio final.",
    propuesta: "Capturar la diferencia de valor mediante regalías diferenciales y obligación de procesamiento mínimo para cátodos de cobre refinado al 99,9% de pureza.",
    cifras: [
      { label: "Captura de metal en concentrado", valor: "20-30%" },
      { label: "Captura por cátodo refinado", valor: "hasta 40%" },
    ],
    instrumentos: ["Regalía diferencial", "Procesamiento obligatorio", "BICE"],
    horizonte: "mediano",
    proyeccion: "Argentina como proveedor estratégico para la transición energética global.",
  },
  {
    id: "uranio",
    nombre: "Uranio y Ciclo Nuclear",
    icon: "Atom",
    capitulo: "Cap. 25 · Parte V",
    metricaPrincipal: "Proyecto Huemul",
    metricaLabel: "reapertura controlada",
    diagnostico: "Argentina es uno de 7 países con capacidad de diseñar, construir y operar reactores nucleares. La minería de uranio está cerrada mientras importamos combustible nuclear.",
    propuesta: "Reapertura minera bajo estándares ambientales y de seguridad radiológica estrictos, con procesamiento obligatorio en la CNEA. Destino prioritario: programa de reactores CAREM-25.",
    cifras: [
      { label: "Ingenieros nucleares a formar", valor: "2.000" },
      { label: "Técnicos a formar", valor: "8.000" },
      { label: "Plazo", valor: "10 años" },
    ],
    instrumentos: ["FDRE", "CNEA", "Plan Nuclear 2030", "CAREM-25"],
    horizonte: "largo",
    proyeccion: "Dominio completo del ciclo del combustible nuclear y exportación de tecnología.",
  },
  {
    id: "vaca-muerta",
    nombre: "Vaca Muerta — Gas y Petróleo",
    icon: "Flame",
    capitulo: "Cap. 19 · Parte V",
    metricaPrincipal: "De molécula a industria",
    metricaLabel: "exportación transformada",
    diagnostico: "Vaca Muerta es activo extraordinario, pero su verdadero valor no es vender gas y petróleo crudos al mundo: es permitir industrialización profunda y sustituir importaciones de combustibles refinados.",
    propuesta: "Tres destinos para el gas: 1) Abastecer demanda interna con previsibilidad, 2) Alimentar petroquímica, fertilizantes, plásticos, refinados, 3) Exportar excedentes como GNL, combustibles refinados y productos derivados.",
    cifras: [
      { label: "BTU como gas crudo", valor: "renta mínima" },
      { label: "BTU como producto industrial", valor: "renta + empleo + tecnología" },
    ],
    instrumentos: ["YPF estratégica", "FDRE", "Petroquímica nacional", "Regalías diferenciales"],
    horizonte: "mediano",
    proyeccion: "Argentina exportador neto de energía transformada, no de moléculas.",
  },
  {
    id: "nuclear",
    nombre: "Energía Nuclear",
    icon: "Zap",
    capitulo: "Cap. 19 · Parte V",
    metricaPrincipal: "Plan Nuclear 2030",
    metricaLabel: "Atucha III + serie CAREM",
    diagnostico: "Argentina tiene tradición nuclear, organismos especializados, empresas capaces y recursos humanos formados. Pero el programa avanza por inercia, sin financiación blindada.",
    propuesta: "Plan Nuclear Argentino 2030: Atucha III, producción serial de reactores CAREM-25, cadena nacional de combustible, formación masiva de cuadros técnicos y exportación de tecnología.",
    cifras: [
      { label: "Ingenieros", valor: "2.000" },
      { label: "Técnicos", valor: "8.000" },
      { label: "Reactores CAREM en serie", valor: "n+1" },
    ],
    instrumentos: ["FDRE (financiación blindada)", "CNEA", "Atucha III", "CAREM-25"],
    horizonte: "largo",
    proyeccion: "Alta densidad energética + capacidad tecnológica nacional + exportable.",
  },
  {
    id: "renovables",
    nombre: "Energías Renovables",
    icon: "Sun",
    capitulo: "Cap. 19 · Parte V",
    metricaPrincipal: "Matriz diversificada",
    metricaLabel: "eólica + solar + biomasa",
    diagnostico: "Argentina tiene condiciones extraordinarias (Patagonia eólica, NOA y Cuyo solares) pero la política energética no puede ser obediencia a modas globales.",
    propuesta: "Integrar renovables a una matriz diversificada junto a gas (transición e industrialización), nuclear (base firme), hidroeléctrica (regulación), biomasa y carbón (reserva térmica estratégica).",
    cifras: [
      { label: "Fuentes integradas", valor: "6+" },
    ],
    instrumentos: ["Matriz energética soberana", "FDRE"],
    horizonte: "mediano",
    proyeccion: "Eficiencia y competitividad de renovables integradas al sistema.",
  },
  {
    id: "hidro",
    nombre: "Hidroeléctrica y Agua",
    icon: "Droplets",
    capitulo: "Cap. 19 · Parte V",
    metricaPrincipal: "Soberanía hídrica",
    metricaLabel: "regulación + energía",
    diagnostico: "Las represas no son sólo generación eléctrica: son regulación hídrica, control de crecidas, reserva de agua, infraestructura productiva, integración territorial.",
    propuesta: "Modernizar represas existentes, recuperar eficiencia, planificar nuevas obras ambiental y socialmente justificables, vincular política hídrica con política energética.",
    cifras: [
      { label: "Líneas de alta tensión", valor: "ampliación" },
      { label: "Microrredes renovables", valor: "regionales" },
    ],
    instrumentos: ["Política energética territorial", "Tarifas diferenciales para industria"],
    horizonte: "mediano",
    proyeccion: "Energía subsidiada para procesamiento local (alimentos, madera, minería, frío).",
  },
  {
    id: "refinacion",
    nombre: "Refinación y Petroquímica",
    icon: "Factory",
    capitulo: "Cap. 19 · Parte V",
    metricaPrincipal: "Sustitución importaciones",
    metricaLabel: "combustibles refinados",
    diagnostico: "Exportar crudo e importar combustibles refinados es dependencia elemental: entregamos valor en el punto más bajo y lo recompramos en el más alto.",
    propuesta: "Modernizar refinerías, construir nuevas plantas, desarrollar petroquímica asociada al gas, fabricar fertilizantes nitrogenados, garantizar combustibles para transporte, agro, pesca, minería y logística.",
    cifras: [
      { label: "Capacidad de refinación", valor: "ampliada" },
      { label: "Petroquímica", valor: "asociada al gas" },
    ],
    instrumentos: ["YPF estratégica", "BICE", "Política industrial"],
    horizonte: "mediano",
    proyeccion: "Energía barata como insumo competitivo de la industria argentina.",
  },
  {
    id: "pesca",
    nombre: "Pesca y Acuicultura",
    icon: "Fish",
    capitulo: "Cap. 21 · Parte V",
    metricaPrincipal: "BL-120",
    metricaLabel: "barcaza modular nacional",
    diagnostico: "El pescado ocupa lugar secundario en la mesa argentina: caro, tarde o ausente en muchas regiones. El problema es logístico, fiscal, industrial y cultural, no biológico.",
    propuesta: "IVA 0% en toda la cadena. Contribución única del 5% al FLE. Red Nacional Hidro-Logística (puertos interiores, plantas de hielo, frío, fileteado). Barcaza Liviana Modular BL-120 estandarizada (100-120 ton).",
    cifras: [
      { label: "IVA eliminado en cadena", valor: "100%" },
      { label: "Contribución a infraestructura", valor: "5%" },
      { label: "Barcazas BL-120 (capacidad)", valor: "100-120 t" },
    ],
    instrumentos: ["IVA diferencial", "FLE", "BL-120", "Red Hidro-Logística", "BVA trazabilidad"],
    horizonte: "mediano",
    proyeccion: "Pescado como proteína federal accesible; empleo en astilleros, frío y acuicultura.",
  },
  {
    id: "carne",
    nombre: "Ganadería Bovina",
    icon: "Beef",
    capitulo: "Cap. 26 · Parte V",
    metricaPrincipal: "USD 40 → USD 120",
    metricaLabel: "exportado por animal",
    diagnostico: "Argentina exporta cortes con industrialización mínima en lugar de cortes premium grass-fed, carnes elaboradas, cueros industrializados, gelatinas, colágenos, biogás y biofertilizantes.",
    propuesta: "Cortes premium con denominación de origen, certificación grass-fed/Halal, industrialización de subproductos (cueros, colágenos, biogás), exportación a mercados premium.",
    cifras: [
      { label: "Valor por animal — hoy", valor: "USD 40" },
      { label: "Valor por animal — objetivo", valor: "USD 120" },
      { label: "Multiplicador", valor: "x3" },
    ],
    instrumentos: ["Certificación Halal", "Denominación de origen", "BICE"],
    horizonte: "mediano",
    proyeccion: "Argentina como cocina del mundo, no granero del mundo.",
  },
  {
    id: "avicultura",
    nombre: "Avicultura",
    icon: "Bird",
    capitulo: "Cap. 26 · Parte V",
    metricaPrincipal: "x5",
    metricaLabel: "capacidad de faena en 5 años",
    diagnostico: "Argentina tiene la eficiencia de conversión alimentaria más alta del mundo pero no la capitaliza plenamente.",
    propuesta: "Quintuplicar capacidad de faena en 5 años, obtener certificación sanitaria internacional, líneas diferenciadas (pollo orgánico, halal, ovoproductos industriales) y alimento balanceado nacional.",
    cifras: [
      { label: "Capacidad de faena (5 años)", valor: "x5" },
      { label: "Líneas diferenciadas", valor: "orgánico/halal/ovo" },
    ],
    instrumentos: ["Certificación sanitaria internacional", "BICE", "Alimento balanceado nacional"],
    horizonte: "mediano",
    proyeccion: "Avicultura argentina exportadora premium.",
  },
  {
    id: "lacteos",
    nombre: "Lácteos",
    icon: "Milk",
    capitulo: "Cap. 26 · Parte V",
    metricaPrincipal: "USD 12-25 / kg",
    metricaLabel: "suero proteico vs leche en polvo",
    diagnostico: "Argentina exporta mayoritariamente leche en polvo entera (la forma más barata) en lugar de quesos maduros con denominación de origen, manteca premium, sueros proteicos, proteínas lácteas y fórmulas infantiles.",
    propuesta: "Transformar la exportación hacia productos de mayor valor: quesos maduros, manteca premium, sueros farmacéuticos, proteínas para industria alimentaria y fórmulas infantiles.",
    cifras: [
      { label: "Suero proteico (farmacéutico)", valor: "USD 12-25/kg" },
      { label: "Leche en polvo", valor: "fracción del precio" },
    ],
    instrumentos: ["Denominación de origen", "BICE", "Certificaciones premium"],
    horizonte: "mediano",
    proyeccion: "Cadena láctea premium con marca argentina.",
  },
  {
    id: "porcinos",
    nombre: "Porcinos",
    icon: "PiggyBank",
    capitulo: "Cap. 26 · Parte V",
    metricaPrincipal: "x10",
    metricaLabel: "producción nacional en 5 años",
    diagnostico: "Argentina produce 600 mil ton/año (casi todo consumo interno) mientras países con menos maíz y soja exportan millones. China importa +4M de toneladas anuales.",
    propuesta: "Multiplicar por 10 la producción en 5 años, construir cadena de frío y frigoríficos porcinos en el interior, protocolos sanitarios con China, Corea y Sudeste Asiático, productos elaborados (salames, jamones).",
    cifras: [
      { label: "Producción actual", valor: "600.000 t/año" },
      { label: "Objetivo 5 años", valor: "x10" },
      { label: "Demanda China", valor: "+4M t/año" },
    ],
    instrumentos: ["Cadena de frío", "Protocolos bilaterales", "Frigoríficos interior", "BICE"],
    horizonte: "mediano",
    proyeccion: "Porcinos elaborados argentinos en mercados premium asiáticos.",
  },
  {
    id: "construccion",
    nombre: "Construcción y Vivienda",
    icon: "Building2",
    capitulo: "Cap. 23 · Parte V",
    metricaPrincipal: "Matriz constructiva",
    metricaLabel: "madera + steel framing + metálica",
    diagnostico: "La escala del Capital Ciudadano exige velocidad, diversidad tecnológica, adaptación regional, costos razonables y mano de obra calificada. La construcción húmeda tradicional sola no alcanza.",
    propuesta: "Matriz constructiva diversificada: madera laminada, steel framing, perfiles de hierro y mampostería liviana. Certificación INTI, plantas regionales, crédito BICE y demanda BVA.",
    cifras: [
      { label: "Sistemas constructivos certificados", valor: "4+" },
      { label: "Velocidad de construcción", valor: "industrializada" },
    ],
    instrumentos: ["BICE", "BVA demanda", "INTI certificación", "Madera + Steel + Metálica"],
    horizonte: "mediano",
    proyeccion: "Vivienda rápida, digna, eficiente, durable y argentina para millones.",
  },
  {
    id: "forestal",
    nombre: "Industria Forestal",
    icon: "Trees",
    capitulo: "Cap. 23 · Parte V",
    metricaPrincipal: "Cadena federal",
    metricaLabel: "Misiones · Corrientes · Patagonia",
    diagnostico: "Argentina tiene ventaja extraordinaria en bosques implantados (Misiones, Corrientes, Entre Ríos, Patagonia). Esta riqueza sale como rollizo barato mientras se importan muebles.",
    propuesta: "Aserraderos tecnificados, secado industrial, tableros y vigas laminadas, diseño arquitectónico modular, fábricas regionales de componentes, carpinterías locales, transporte ferroviario.",
    cifras: [
      { label: "Cadena de valor regional", valor: "completa" },
    ],
    instrumentos: ["BICE", "BVA demanda", "INTI", "Ferrocarriles"],
    horizonte: "mediano",
    proyeccion: "Madera estratégica del Capital Ciudadano + empleo en ciudades pequeñas.",
  },
  {
    id: "ferrocarriles",
    nombre: "Ferrocarriles de Carga",
    icon: "Train",
    capitulo: "Cap. 20 · Parte V",
    metricaPrincipal: "5 corredores",
    metricaLabel: "Belgrano · San Martín · Roca · Mitre · Urquiza",
    diagnostico: "El transporte masivo por camión es ineficiente, costoso y genera externalidades negativas (combustible, accidentes, emisiones, congestión). Un país largo y disperso necesita trenes de carga fuertes.",
    propuesta: "Reconstrucción ferroviaria en 5 corredores: Belgrano (NOA-NEA), San Martín (Cuyo), Roca (Patagonia), Mitre (pampeana) y Urquiza (Mesopotamia). Financiamiento plurianual blindado del FLE.",
    cifras: [
      { label: "Corredores prioritarios", valor: "5" },
    ],
    instrumentos: ["FLE", "Financiamiento plurianual blindado"],
    horizonte: "largo",
    proyeccion: "Viabilidad productiva en zonas donde hoy la logística destruye rentabilidad.",
  },
  {
    id: "marina",
    nombre: "Marina Mercante",
    icon: "Anchor",
    capitulo: "Cap. 20 · Parte V",
    metricaPrincipal: "Astilleros nacionales",
    metricaLabel: "buques estratégicos",
    diagnostico: "Un país exportador sin marina mercante propia entrega parte de su comercio exterior antes de vender el primer producto: salida de divisas, dependencia logística y menor capacidad de negociación.",
    propuesta: "Reconstrucción con criterio moderno: empresa pública estratégica + privados nacionales + astilleros locales. Segmentos prioritarios: frigoríficos, graneleros, portacontenedores, tanqueros, cabotaje, barcazas hidrovía.",
    cifras: [
      { label: "Segmentos prioritarios", valor: "6" },
      { label: "Empleos directos", valor: "naval + astilleros + puertos" },
    ],
    instrumentos: ["FLE", "Astilleros nacionales", "Empresa pública estratégica"],
    horizonte: "mediano",
    proyeccion: "Soberanía logística y empleo naval calificado.",
  },
  {
    id: "hidrovia",
    nombre: "Hidrovía y Canal Magdalena",
    icon: "Ship",
    capitulo: "Cap. 20 · Parte V",
    metricaPrincipal: "Salida soberana",
    metricaLabel: "al Atlántico Sur",
    diagnostico: "La salida al mar no es dato geográfico: es decisión logística. La hidrovía es arteria económica continental y su control no puede ser asunto técnico menor.",
    propuesta: "Canal Magdalena como obra de soberanía conectando sistema fluvial argentino con Atlántico Sur. Administración soberana de la hidrovía: provincias + control nacional + auditoría permanente + reinversión en FLE.",
    cifras: [
      { label: "Conexión directa al Atlántico", valor: "Magdalena" },
    ],
    instrumentos: ["FLE", "Administración soberana", "Auditoría pública"],
    horizonte: "mediano",
    proyeccion: "Reducción de dependencia de pasos exteriores y puertos extranjeros.",
  },
  {
    id: "puertos",
    nombre: "Puertos Federales",
    icon: "Container",
    capitulo: "Cap. 20 · Parte V",
    metricaPrincipal: "Red multimodal",
    metricaLabel: "puertos especializados",
    diagnostico: "Argentina necesita dejar de pensar su logística como embudo hacia pocos puertos concentrados.",
    propuesta: "Red de puertos especializados: frigoríficos para proteína y pesca, forestales-industriales, mineros con control ambiental, energéticos, fluviales modernizados, patagónicos integrados a defensa.",
    cifras: [
      { label: "Tipos de puertos especializados", valor: "6+" },
    ],
    instrumentos: ["FLE", "Nodos multimodales"],
    horizonte: "mediano",
    proyeccion: "Abundancia federal con acceso razonable a infraestructura.",
  },
  {
    id: "frio",
    nombre: "Cadena de Frío Nacional",
    icon: "Snowflake",
    capitulo: "Cap. 20 · Parte V",
    metricaPrincipal: "Premium vs commodity",
    metricaLabel: "el frío es la diferencia",
    diagnostico: "Sin frío, la potencia proteica se pierde: carne pierde valor, pescado se remata, fruta se deteriora, lácteos se limitan, acuicultura no escala.",
    propuesta: "Red nacional integrada al FLE y BICE: cámaras regionales, túneles de congelado, contenedores refrigerados, vagones y camiones frigoríficos, terminales portuarias de frío, trazabilidad digital de temperatura.",
    cifras: [
      { label: "Componentes de red", valor: "8+" },
    ],
    instrumentos: ["FLE", "BICE", "BVA trazabilidad"],
    horizonte: "mediano",
    proyeccion: "Vender alimento premium en lugar de commodity.",
  },
  {
    id: "software",
    nombre: "Software y Conocimiento",
    icon: "Code2",
    capitulo: "Cap. 27 · Parte VI",
    metricaPrincipal: "USD 7.500M",
    metricaLabel: "exportación anual actual",
    diagnostico: "Argentina exporta USD 7.500M/año en software pero no capitaliza este potencial en poder nacional. CONICET recortado, investigadores emigrados, laboratorios vaciados = suicidio tecnológico sistemático.",
    propuesta: "Capitalizar el potencial científico-técnico en IA, biotecnología, automatización, robótica, trazabilidad blockchain, satélites, sensores, genética, energía nuclear y sistemas digitales, aplicándolos a problemas concretos del desarrollo nacional.",
    cifras: [
      { label: "Exportación actual", valor: "USD 7.500M/año" },
      { label: "Sectores estratégicos", valor: "9+" },
    ],
    instrumentos: ["BICE", "CONICET fortalecido", "Plan Espacial"],
    horizonte: "largo",
    proyeccion: "Autonomía tecnológica + exportación de soluciones argentinas al mundo.",
  },
  {
    id: "metalurgica",
    nombre: "Industria Metalúrgica",
    icon: "Wrench",
    capitulo: "Cap. 23 · Parte V",
    metricaPrincipal: "Anclas + PyMEs",
    metricaLabel: "escala + capilaridad",
    diagnostico: "Argentina tiene tradición metalúrgica, talleres, soldadores, fábricas de estructuras y cultura industrial capaz de adaptarse a producción de módulos, naves, viviendas y galpones.",
    propuesta: "Empresas ancla (siderurgia, trenes, barcos, satélites, frigoríficos) + red de PyMEs (montaje, terminación, mantenimiento, ampliación, personalización). Política industrial para perfiles, tornillería, placas, aislantes y herramientas.",
    cifras: [
      { label: "Empresas ancla estratégicas", valor: "8+" },
      { label: "Red PyMEs", valor: "federal" },
    ],
    instrumentos: ["BICE", "Política industrial integrada"],
    horizonte: "largo",
    proyeccion: "Capilaridad productiva federal + soberanía tecnológica.",
  },
  {
    id: "trabajo",
    nombre: "Trabajo y Formalización",
    icon: "BriefcaseBusiness",
    capitulo: "Cap. 23 · Parte V",
    metricaPrincipal: "45% → 10-15%",
    metricaLabel: "informalidad en 10 años",
    diagnostico: "El esfuerzo se desvinculó del patrimonio. Millones trabajaron sin construir estabilidad. El salario se fue en alquiler, inflación, deuda e impuestos mal diseñados. La informalidad existe por reglas complejas y cargas mal diseñadas.",
    propuesta: "Reconectar trabajo, ahorro, patrimonio y futuro. Formalizarse debe ser puerta a ventas, crédito BICE, programas de vivienda, recepción de PVA, exportación con certificación. La formalidad debe ser ventaja competitiva, no carga.",
    cifras: [
      { label: "Informalidad hoy", valor: "~45%" },
      { label: "Objetivo a 10 años", valor: "10-15%" },
    ],
    instrumentos: ["Capital Ciudadano", "BICE", "BVA", "Reglas claras"],
    horizonte: "mediano",
    proyeccion: "Empleo formal, calificado, distribuido territorialmente y vinculado a cadenas de valor reales.",
  },
  {
    id: "comercio",
    nombre: "Comercio Exterior",
    icon: "Globe2",
    capitulo: "Cap. 30 · Parte VI",
    metricaPrincipal: "Integración soberana",
    metricaLabel: "diversificada y autónoma",
    diagnostico: "Argentina debe desarrollar relaciones comerciales sin subalternarse a ninguna potencia ni ceder recursos estratégicos ni soberanía regulatoria.",
    propuesta: "Relaciones con China, EE.UU., Europa, Rusia, mundo árabe, Sudeste Asiático, África y América Latina. Tres principios: ofrecer abundancia a cambio de industrialización, nunca ceder soberanía, diversificar vínculos.",
    cifras: [
      { label: "Bloques económicos activos", valor: "8" },
    ],
    instrumentos: ["Agencia Argentina de Integración Productiva Global"],
    horizonte: "largo",
    proyeccion: "Política exterior activa, diversificada y soberana.",
  },
];

// Mapeo Capítulo → página PDF (Resumen por capítulos — 5 páginas).
// La página 1 es introducción; las páginas 2-5 contienen los capítulos agrupados.
const CAPITULO_PAGINA = {
  1: 2, 2: 2, 3: 2, 4: 2, 5: 2, 6: 2, 7: 2, 8: 2,
  9: 3, 10: 3, 11: 3, 12: 3, 13: 3, 14: 3, 15: 3,
  16: 4, 17: 4, 18: 4, 19: 4, 20: 4, 21: 4, 22: 4, 23: 4,
  24: 5, 25: 5, 26: 5, 27: 5, 28: 5, 29: 5, 30: 5,
};

// Extrae el N° del capítulo desde un string tipo "Cap. 24 · Parte V"
export const getPaginaPDFCapitulo = (capituloStr) => {
  if (!capituloStr) return null;
  const m = capituloStr.match(/Cap\.?\s*(\d+)/i);
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return CAPITULO_PAGINA[n] || null;
};
